<label class="toggle-switch">
  <input
    class="toggle-switch__input"
    type="checkbox"
    [checked]="value"
    [name]="name"
    [disabled]="disabled"
    [attr.tabindex]="tabindex"
    (change)="onChange($event)"
  />

  <span class="toggle-switch__toggle">
    <vtmn-play-icon
      [name]="iconName"
      class="toggle-switch__toggle__round"
    ></vtmn-play-icon>
  </span>

  <span
    [class.toggle-switch__label--disabled]="disabled"
    class="toggle-switch__label"
  >
    {{ label }}
  </span>
</label>
